import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AlertInfo, AlertService, AlertType } from './Alert/alert.service';

@Injectable()
export class BaseService {
  protected url: string;

  constructor(
    route: string,
    private alertService: AlertService
  ) {
    this.url = environment.apiBaseUrl + route;
  }

  handleError(
    title: string,
    err: Response | any,
    type: AlertType = AlertType.Error,
    closeable: boolean = true
  ): Observable<any> {
    this.alertService.setAlert(<AlertInfo>{
      title: title,
      message: err?.error?.message,
      type: type,
      closeable: closeable,
    });
    return of();
  }

  clearAlert() {
    this.alertService.clearAlert();
  }
}
